(() => {
  const createTransition = () => {
    if (document.querySelector('.bs-page-transition')) return document.querySelector('.bs-page-transition');
    const el = document.createElement('div');
    el.className = 'bs-page-transition';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="bs-page-transition__mark"><span class="bs-page-transition__monogram">BS</span><span class="bs-page-transition__line"></span><span class="bs-page-transition__text">WEAR THE MARK</span></div>';
    document.body.appendChild(el);
    return el;
  };

  const normalizeCopy = (root = document) => {
    root.querySelectorAll('[data-atc-text]').forEach((el) => {
      const text = el.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === 'add to cart' || text === 'in den warenkorb') el.textContent = 'ADD TO BAG';
    });

    root.querySelectorAll('button[name="add"][aria-label]').forEach((button) => {
      const label = (button.getAttribute('aria-label') || '').toLowerCase();
      if (label.includes('cart') || label.includes('warenkorb')) button.setAttribute('aria-label', 'Add product to bag');
    });
  };

  const boot = () => {
    const transition = createTransition();
    normalizeCopy(document);

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link) return;
      if (link.hasAttribute('download') || link.target === '_blank' || link.hasAttribute('product-quickview-btn')) return;
      if (link.closest('[data-close-drawer], [data-drawer-close], quick-view')) return;

      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || raw.startsWith('javascript:')) return;

      let url;
      try { url = new URL(link.href, window.location.href); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;

      event.preventDefault();
      transition.classList.add('is-active');
      window.setTimeout(() => window.location.assign(url.href), 145);
    }, true);

    window.addEventListener('pageshow', () => transition.classList.remove('is-active'));

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) normalizeCopy(node);
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
